"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.positionMapper = exports.networkMapper = exports.cardTypeMapper = void 0;
const enum_mapper_1 = require("../utils/enum-mapper");
const video_cards_1 = require("@wix/wix-vod-constants/video-cards");
const globalTypes_1 = require("../private/generated/globalTypes");
exports.cardTypeMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.VideoCardType.CHANNEL]: video_cards_1.VIDEO_CARD_TYPES.CHANNEL,
    [globalTypes_1.VideoCardType.VIDEO]: video_cards_1.VIDEO_CARD_TYPES.VIDEO,
    [globalTypes_1.VideoCardType.CUSTOM]: video_cards_1.VIDEO_CARD_TYPES.CUSTOM,
    [globalTypes_1.VideoCardType.PRODUCT]: video_cards_1.VIDEO_CARD_TYPES.PRODUCT,
    [globalTypes_1.VideoCardType.RECENT_VIDEO]: video_cards_1.VIDEO_CARD_TYPES.RECENT_VIDEO,
    [globalTypes_1.VideoCardType.SOCIAL]: video_cards_1.VIDEO_CARD_TYPES.SOCIAL,
});
exports.networkMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.VideoCardTargetExternalType.FACEBOOK]: video_cards_1.SOCIAL_SOURCES.FACEBOOK,
    [globalTypes_1.VideoCardTargetExternalType.TWITTER]: video_cards_1.SOCIAL_SOURCES.TWITTER,
    [globalTypes_1.VideoCardTargetExternalType.YOUTUBE]: video_cards_1.SOCIAL_SOURCES.YOUTUBE,
});
exports.positionMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.VideoCardPosition.BOTTOM_LEFT]: video_cards_1.VIDEO_CARDS_POSITIONS.BOTTOM_LEFT,
    [globalTypes_1.VideoCardPosition.BOTTOM_RIGHT]: video_cards_1.VIDEO_CARDS_POSITIONS.BOTTOM_RIGHT,
    [globalTypes_1.VideoCardPosition.TOP_LEFT]: null,
    [globalTypes_1.VideoCardPosition.TOP_RIGHT]: null,
});
//# sourceMappingURL=video-cards.js.map